<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0" v-if="$route.name === names.SCIENCE_ID.OAUTH">
    <div class="page__title">
      Авторизация через Science-ID
    </div>
    <div v-if="!loading">
      <div class="page__subtitle" v-if="error">
        При попытке авторизации произошла ошибка
      </div>
      <div class="text_field__container" v-if="error">
        <div class="text__field">
          <v-alert
              class="error_alert"
              :value="true"
              outline
              :icon="false"
              color="#8f0808"
              variant="outlined"
          >
            {{ error.error }}
          </v-alert>
        </div>
        <div class="page__text">
          {{ error.subtext }}
        </div>
        <div v-if="error" class="btn__next" @click="$router.push({name: names.MAIN})">
          <span class="btn__next_text">
            На главную
          </span>
        </div>
      </div>
      <div v-else-if="no_find">
        <div class="page__subtitle px-md-10 px-lg-15">
          Уважаемый пользователь, <br>
          Для авторизации на сайте «Менделеевская карта» при помощи аккаунта SCIENCE-ID вам необходимо получить карту на странице профиля, нажав кнопку «Получить Менделеевскую карту». <br>
          После этого вы сможете авторизоваться на сайте проекта «Менделеевская карта» при помощи SCIENCE-ID.
        </div>
        <div v-show="show_next_btn" class="btn__next" @click="$router.push({name: pa_names.MAIN})">
          <span class="btn__next_text">
            Далее
          </span>
        </div>
      </div>
      <div v-else>
        <div class="page__subtitle">
          Ожидайте, скоро вы будете перенаправлены
        </div>
        <div v-show="show_next_btn" class="btn__next" @click="$router.push({name: pa_names.MAIN})">
          <span class="btn__next_text">
            Далее
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import { set_stores } from "@/store/modules/auth"
import { FulfillingSquareSpinner } from "epic-spinners"

export default defineComponent({
  name: "OauthScienceId",
  mixins: [FormErrorsMixin],
  components: { FulfillingSquareSpinner },
  data () {
    return {
      loading: false,
      error: null,
      show_next_btn: false,
      no_find: false
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    set_stores: set_stores,
    ...mapActions({
      loginScienceId: 'auth/SCIENCE_ID_OAUTH_LOGIN',
      searchScienceId: 'personal_account/science_id/searchScienceId',
    }),
    endRedirect (member = false) {
      if (!member) {
        this.$router.push({ name: names.REGISTRATION.PAGE })
      } else {
        this.$router.push({ name: pa_names.MAIN })
      }
    },
    authScienceId (token) {
      this.loading = true
      this.error = null
      this.loginScienceId(
        {
          token: { token: token },
          finalizer: (data) => {
            this.loading = false
            this.error = null
            this.set_stores(data.token, data.email, "")
            setTimeout(() => {
              this.endRedirect(data.member)
            }, 300)
          },
          catcher: (error) => {
            this.loading = false
            this.error = error
            if (error.error && error.error === 'Авторизация через SCIENCE-ID не доступна') {
              error.subtext = "По полученным учетным данным не был найден пользователь в системе Science-id. Возможно, произошла ошибка при запросе данных или что-то пошло не так."
            } else {
              error.subtext = "Для авторизации через SCIENCE-ID требуется связать аккаунты участника Менделеевской карты и SCIENCE-ID."
            }
          }
        }
      )
    },
    searchScienceIdData: function (id) {
      this.loading = true
      this.error = null
      this.no_find = false
      this.searchScienceId(
        {
          data: {
            type: "Oauth",
            token: id
          },
          finalizer: (data) => {
            if (data.is_found && data.is_linked) {
              this.authScienceId(this.$route.query.token)
            } else if (data.is_found && !data.is_linked) {
              this.$router.push({ name: names.SCIENCE_ID.BIND, query: { token: id, type: 'Oauth' } })
            } else {
              this.no_find = true
              setTimeout(() => {
                this.endRedirect()
              }, 15000)
              setTimeout(() => {
                this.show_next_btn = true
              }, 3000)
            }
            this.loading = false
            this.error = null
          },
          catcher: (error) => {
            this.loading = false
            this.error = error
          }
        }
      )
    },
  },
  created () {
    // если есть токен, то делаю еще запрос (пункт 1) ---> (is_linked ---> next); (is_found & !is_linked ---> связать аккаунт новая страница)
    if (this.$route.query.token && !this.isAuthenticated) {
      this.searchScienceIdData(this.$route.query.token)
    } else {
      this.$router.push({ name: names.MAIN })
    }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.page__text {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: normal;
  text-align: center;

  color: #858484;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 700px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 220px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .text_field__container {
    width: 500px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
